import Popup from '~/components/Popup';
import Radio, { OwnFieldProps as RadioProps } from '~/components/Radio';
import { Option } from '~/components/Select';
import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';
import { InjectedTranslateProps, translate } from '~/utils/translate';
import { FormGroup } from './PackageTemplateRadioGroup.styled';

interface PackageTemplateRadioGroupProps {
  onChangeCallback(option: Option): void;
  dimensionType: Maybe<Option>;
}

const PackageTemplateRadioGroup = ({
  onChangeCallback,
  dimensionType,
  t,
  input,
  ...selectedProps
}: PackageTemplateRadioGroupProps & RadioProps & InjectedTranslateProps & WrappedFieldProps) => {
  const updatePackageRadio = React.useCallback((val) => {
    onChangeCallback(val as Option);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const PackageTooltip = (
    <Popup
      on="hover"
      inverted
      size="mini"
      position="top center"
      trigger={<i className="fa fa-question-circle" />}
    >
      {t('orders:packageDimensionTypes:polymailerTooltipText')}
    </Popup>
  );

  return (
    <FormGroup>
      <Radio
        name="packageDimensionType"
        onChange={updatePackageRadio}
        value={dimensionType ? dimensionType : input.value}
        vertical
        toolTipContent={PackageTooltip}
        {...selectedProps}
      />
    </FormGroup>
  );
};

const ComposedPackageTemplateRadioGroup = translate('orders')(PackageTemplateRadioGroup);

export default ComposedPackageTemplateRadioGroup;
